// types uses by the anaytics providers

export const SET_LANGUAGE = "SET_LANGUAGE";

export const SET_PAGE = "SET_PAGE";
export const PAGE_VIEW = "PAGE_VIEW";

export const EVENT = "EVENT";

export const TIMING = "TIMING";

export const SET_USER_ID = "SET_USER_ID";

export const SET_APP_ID = "SET_APP_ID";
export const SET_APP_VERSION = "SET_APP_VERSION";
export const SET_APP_NAME = "SET_APP_NAME";

export const START_SESSION = "START_SESSION";
export const END_SESSION = "END_SESSION";
